<template>
    <input ref="input" />
</template>

<script lang="ts">
import { Component, Prop, Watch } from "vue-property-decorator";
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { mixins, Options, Vue } from "vue-class-component";
import WithModel from "@/mixins/withModel";

@Options({})
export default class OpDateTime extends mixins(WithModel) {

    @Prop({
        required: false,
        default: 'd/m/Y H:i'
    }) format: string;
    @Prop() initialvalue: any;
    @Prop() minDate: any;
    @Prop() inline: boolean;

    fp: any = null;
    mounted(){
        var date = new Date().toISOString();
        if(this.modelValue){
            date = new Date(this.modelValue).toISOString();
        } else {
            if(this.initialvalue !== undefined){
                date = this.initialvalue;
            } else {
                this.emitModel(new Date(date).toISOString());
            }
        }

        this.fp = flatpickr(this.$refs.input as HTMLInputElement, {
            defaultDate: date,
            dateFormat: this.format,
            allowInput: true,
            enableTime: true,
            inline: !!this.inline,
            time_24hr: true,
            parseDate: (datestr, format) => {
                let date = new Date(datestr);
                if(this.isValidDate(date) && date.toISOString() == datestr){
                    this.emitModel(date.toISOString());
                    return date;
                }

                if(datestr.indexOf("/") > -1 || datestr.indexOf("-") > -1 || datestr.indexOf(".") > -1){
                    datestr = datestr.replaceAll("/", "");
                    datestr = datestr.replaceAll("-", "");
                    datestr = datestr.replaceAll(".", "");
                }
                var giorno = datestr.substring(0, 2);
                var mese = datestr.substring(2, 4);
                var anno = datestr.substring(4, 8);
                var ora = datestr.substring(8, datestr.indexOf(":"));
                var minuti = datestr.substring(datestr.indexOf(":") + 1);

                let ris = new Date(parseInt(anno), parseInt(mese) - 1, parseInt(giorno));
                if(ora){
                    ris.setHours(parseInt(ora));
                }
                if(minuti){
                    ris.setMinutes(parseInt(minuti));
                }
                this.emitModel(ris.toISOString());
                return ris;
            },
            onChange: (val) => {
                this.emitModel(new Date(this.validateDate(val[0])).toISOString());
            },
            minDate: this.minDate
        });
    }

    @Watch('modelValue')
    onValueChange(next, prev){
        var data = null;
        if(next !== null){
            data = new Date(next).toISOString();
        }
        this.fp.setDate(data, false);
    }

    validateDate(inputDate: Date){
        if(this.isValidDate(inputDate)){
            return inputDate.toISOString();
        }
    }
    
    isValidDate(d: any) {
        return d instanceof Date && !isNaN(d as any);
    }

}
</script>

<style scoped>

</style>